module.exports = __webpack_public_path__ + "static/media/icono_admin.60eacafd.svg";